import { WeekDay } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';

@Component({
  selector: 'app-kit-detail',
  templateUrl: './kit-detail.page.html',
  styleUrls: ['./kit-detail.page.scss']
})
export class KitDetailPage implements OnInit {
  @Input() itemKit
  optionsDays = {
    weekStart: WeekDay.Monday,
    activeBgColor: '#7a00e6',
    activeBorderColor: '#7a00e6',
    inactiveColor: '#7a00e6',
    inactiveBgColor: '#fff',
    inactiveBorderColor: '#7a00e6',
    borderWidth: '1px',
    daysNames: ['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab', 'Dom'],
    disabledList: [
      WeekDay.Monday,
      WeekDay.Tuesday,
      WeekDay.Wednesday,
      WeekDay.Thursday,
      WeekDay.Friday,
      WeekDay.Saturday,
      WeekDay.Sunday
    ]
  }

  selectDays = []
  messageSupport =
    'Hola%2c+estoy+usando+GoDx+y+requiero+de+soporte+t%c3%a9cnico+en+el+m%c3%b3dulo+de+Historial+con+una+solicitud+de+Kits'

  constructor(private modalController: ModalController, public platform: Platform) {}

  ngOnInit() {
    this.selectDays = this.itemKit.horary.map((e) => parseInt(e.day))
    
    // Transformar y ordenar eventos si existen
    if (this.itemKit && this.itemKit.events && Array.isArray(this.itemKit.events)) {
      // Transformar nombres de eventos ANTES de ordenar
      this.itemKit.events.forEach(event => {
        event.event_name = this.transformEventName(event.event_name);
      });

      // Ordenar eventos cronológicamente considerando ID si las fechas conciden
      this.itemKit.events = this.itemKit.events.sort((a, b) => {
        // Eventos sin fecha van al final
        if (!a.date || a.date.length === 0) return 1;
        if (!b.date || b.date.length === 0) return -1;
        
        const dateA = this.parseDate(a.date);
        const dateB = this.parseDate(b.date);
        
        // Primero ordenar por fecha
        const dateComparison = dateA.getTime() - dateB.getTime();
        if (dateComparison !== 0) {
          return dateComparison; // Fechas diferentes
        }
        
        // Si fechas iguales, ordenar por ID
        return a.id - b.id;
      });
    }
  }

  /**
   * Verifica si hay fechas válidas en los horarios
   */
  hasValidDates(): boolean {
    if (!this.itemKit.horary || this.itemKit.horary.length === 0) {
      return false;
    }
    
    return this.itemKit.horary.some(horario => this.isValidDate(horario.date));
  }

  /**
   * Valida si una fecha es válida
   */
  isValidDate(dateString: string): boolean {
    if (!dateString) return false;
    return dateString.includes('/') && dateString !== "Fecha no disponible";
  }

  /**
   * Formatea una fecha para mostrar solo DD/MM/YYYY
   */
  formatDate(dateString: string): string {
    if (dateString && dateString.includes('/')) {
      const parts = dateString.split(' ');
      if (parts.length > 0) {
        return parts[0]; // Devuelve solo "DD/MM/YYYY"
      }
    }
    
    return dateString || 'Fecha no disponible';
  }

  /**
   * Formatea una hora para mostrar en formato HH:mm
   */
  formatTime(timeString: string): string {
    if (!timeString) return '';
    
    // Si ya tiene formato HH:mm, devolverlo tal cual
    if (timeString.includes(':')) {
      return timeString;
    }
    
    // Si es solo número, agregar :00
    return `${timeString}:00`;
  }

  /**
   * Transforma nombres de eventos de seguimiento al nuevo formato
   * @param eventName - Nombre original del evento
   * @returns Nombre transformado
   */
  private transformEventName(eventName: string): string {
    if (!eventName) return '';
    
    const transformations = {
      'Detalles de seguimiento Uno': 'Seguimiento #1',
      'Detalles de seguimiento Dos': 'Seguimiento #2', 
      'Detalles de seguimiento Tres': 'Seguimiento #3',
      'Detalles de seguimiento Cuatro': 'Seguimiento #4',
      'Detalles de seguimiento Cinco': 'Seguimiento #5'
    };
    
    return transformations[eventName] || eventName;
  }

  /**
   * Parsea una fecha en formato DD/MM/YYYY
   * @param dateString - String de fecha a parsear
   * @returns Date object
   */
  private parseDate(dateString: string): Date {
    if (!dateString) return new Date(0);
    
    // Manejar formato DD/MM/YYYY
    if (dateString.includes('/')) {
      const parts = dateString.split(' ')[0].split('/'); // Solo la parte de fecha
      if (parts.length === 3) {
        return new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
      }
    }
    
    // Fallback: conversión directa
    return new Date(dateString);
  }

  async closeModal() {
    await this.modalController.dismiss()
  }
}
